// CRM 2.0 customer actions (M3): KYC files, Agreement KYC submit, Application for Booking and review
// draft confirmation by server OTP. Backend: routes/crm2Portal.js (needs the portal session).
import axios from "axios";
import { portalHeaders, unwrapOtp } from "./ServerOtp";

const apiUrl = `${process.env.REACT_APP_PAYMENT_LINK_URL}crm2/portal`;
const get = (url) => unwrapOtp(axios.get(`${apiUrl}${url}`, { headers: portalHeaders() }));
const post = (url, body) => unwrapOtp(axios.post(`${apiUrl}${url}`, body, { headers: portalHeaders() }));

// KYC file through the server → { documentId, versionNo, ref: "crm2doc:<id>/<name>", name }
export const uploadKycFile = (apId, docTypeKey, applicantNo, file) => {
	const fd = new FormData();
	fd.append("apId", apId);
	fd.append("docTypeKey", docTypeKey);
	fd.append("applicantNo", String(applicantNo));
	fd.append("file", file);
	return unwrapOtp(axios.post(`${apiUrl}/documents/upload`, fd, { headers: portalHeaders() }));
};
// "crm2doc:<documentId>/<name>" → 10-minute link
export const CRM2_DOC_PREFIX = "crm2doc:";
export const isCrm2DocRef = (v) => typeof v === "string" && v.startsWith(CRM2_DOC_PREFIX);
export const crm2DocLink = (apId, ref) => get(`/documents/${String(ref).slice(CRM2_DOC_PREFIX.length).split("/")[0]}/link?apId=${apId}`);

export const getCrm2Kyc = (apId) => get(`/kyc/${apId}`);
export const submitCrm2Kyc = (apId, body) => post(`/kyc/${apId}/submit`, body);

export const getAfb = (apId) => get(`/afb/${apId}`);
export const sendAfbOtp = (apId) => post(`/afb/${apId}/otp`, {});
export const confirmAfb = (apId, challengeId, code) => post(`/afb/${apId}/confirm`, { challengeId, code });

export const getReviewDraft = (apId) => get(`/review-draft/${apId}`);
export const sendReviewOtp = (apId, documentId, applicantId) => post(`/review-draft/${apId}/otp`, { documentId, applicantId });
export const confirmReview = (apId, documentId, applicantId, challengeId, code) => post(`/review-draft/${apId}/confirm`, { documentId, applicantId, challengeId, code });

// Cancel Unit + refund bank details (M3-F10)
export const getCancelState = (apId) => get(`/cancel/${apId}`);
export const sendCancelOtp = (apId, applicantId) => post(`/cancel/${apId}/otp`, { applicantId });
export const requestCancel = (apId, body) => post(`/cancel/${apId}/request`, body);
export const submitRefundBank = (apId, body) => post(`/cancel/${apId}/refund-bank`, body);
// M7-F9 (DC-120): confirm or reject a VJ-raised cancellation; OTP to the applicant the customer picks
export const sendConsentOtp = (apId, applicantId) => post(`/cancel/${apId}/consent/otp`, { applicantId });
export const confirmConsent = (apId, body) => post(`/cancel/${apId}/consent/confirm`, body);
export const rejectConsent = (apId, applicantId) => post(`/cancel/${apId}/consent/reject`, { applicantId });
// M8-F7 / F8: Allotment Letter step — the letter + eSign state, 10-minute PDF link, Sign with Aadhaar (Surepass), return page
export const getAllotmentLetter = (apId) => get(`/allotment-letter/${apId}`);
export const allotmentLetterLink = (apId, which = "letter") => get(`/allotment-letter/${apId}/link?which=${which}`);
export const startLetterEsign = (apId, applicantId) => post(`/allotment-letter/${apId}/esign/start`, { applicantId });
export const completeLetterEsign = (apId) => post(`/allotment-letter/${apId}/esign/complete`, {});

// Documents page (M3-F12)
export const listCrm2Documents = (apId) => get(`/documents/${apId}/list`);
// the zip comes back as the file itself → { blob, fileName }
export const zipCrm2Documents = async (apId) => {
	try {
		const r = await axios.post(`${apiUrl}/documents/${apId}/zip`, {}, { headers: portalHeaders(), responseType: "blob" });
		const m = /filename="([^"]+)"/.exec(r.headers["content-disposition"] || "");
		return { blob: r.data, fileName: m ? m[1] : "documents.zip" };
	} catch (err) {
		let message = "Could not make the zip. Please try again.";
		try {
			message = JSON.parse(await err.response.data.text()).message || message;
		} catch (e) {}
		console.log("[crm2] zip failed", { apId, status: err?.response?.status });
		throw new Error(message);
	}
};
export const crm2DocLinkById = (apId, documentId) => get(`/documents/${documentId}/link?apId=${apId}`);

// Discounts (M4-F6): the open decision + figures for the pop-ups; the customer's choice (preview, then confirm)
export const getCrm2Discounts = (apId) => get(`/discounts/${apId}`);
// M6-F8: { status: ACTIVE | CLOSED | NOT_CREATED, usedBy: [unit labels], hasCrm2 }
export const getCrm2VaStatus = () => get("/va");
export const decideCrm2Discount = (apId, decision, confirm) => post(`/discounts/${apId}/decide`, { decision, confirm: !!confirm });
